import { ExportableResourceService } from 'shared/services/ExportableResourceService';
import { IExamProductWarehouse } from '../types';

class ExamProductWarehouseService extends ExportableResourceService<IExamProductWarehouse> {
  constructor() {
    super('exam-products');
  }
}

export const examProductWarehouseService = new ExamProductWarehouseService();
